// extracted by mini-css-extract-plugin
export default {"name":"MutableName_name__rzpVb","nameLeft":"MutableName_nameLeft__WW8P4","nameRight":"MutableName_nameRight__jvyGD"};